export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10273.5cfba598.jpg";